import DirectionsCarIcon from "@mui/icons-material/DirectionsCar";
import { lang } from "../Utils/lang";
import { localUrlEnum } from "../Utils/urlEnum";

export const ROUTER_DASHBOARD = {
  routes: ["/", "/login",localUrlEnum.users, "*"],
};

export const MAIN_SLIDER_USERS = [
  {
    name: lang.users,
    path: localUrlEnum.users,
    icon: <DirectionsCarIcon />,
    orderId: 0,
  },
];
